import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiGrid, FiList } from 'react-icons/fi';
import RiskList from '../../components/Risks/RiskList';
import RiskMatrix from '../../components/Risks/RiskMatrix';
import riskService from '../../services/riskService';
import './Risks.css';

const Risks = () => {
  const navigate = useNavigate();
  const [view, setView] = useState('list'); // 'list' or 'matrix'
  const [matrixData, setMatrixData] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (view === 'matrix') {
      loadMatrixData();
    }
  }, [view]);

  const loadMatrixData = async () => {
    try {
      setLoading(true);
      const data = await riskService.getMatrix();
      setMatrixData(data.data);
    } catch (error) {
      console.error('Error loading matrix data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleRiskClick = (risk) => {
    navigate(`/app/risks/${risk.id}`);
  };

  return (
    <div className="risks-page">
      <div className="risks-page-header">
        <h1 className="risks-page-title">Risk Management</h1>
        <div className="risks-view-toggle">
          <button
            className={`view-toggle-btn ${view === 'list' ? 'active' : ''}`}
            onClick={() => setView('list')}
          >
            <FiList />
            List View
          </button>
          <button
            className={`view-toggle-btn ${view === 'matrix' ? 'active' : ''}`}
            onClick={() => setView('matrix')}
          >
            <FiGrid />
            Matrix View
          </button>
        </div>
      </div>

      {view === 'list' ? (
        <RiskList showStatistics={true} />
      ) : (
        <div className="risks-matrix-view">
          {loading ? (
            <div className="risks-matrix-loading">Loading risk matrix...</div>
          ) : (
            <RiskMatrix matrixData={matrixData} onRiskClick={handleRiskClick} />
          )}
        </div>
      )}
    </div>
  );
};

export default Risks;

